import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL_CONSTANTS } from '../../../constants/apiUrlConstants';
import { mob_winnerboard} from '../../../constants/iconImageConstant';
import { Header } from '../../Header/Header';
import { Footer } from '../../appFooter/Footer';

interface ImageDetail {
  id: string;
  name: string;
  image: string;
  //age:string;
  age : string |null;
  drawing: string;
}

export function Mob_ArtistGallery_2024() {
  const url = API_URL_CONSTANTS.BASE_URL + API_URL_CONSTANTS.PAINTATHON_RESULT;
  const [images, setImages] = useState<ImageDetail[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedDrawing, setSelectedDrawing] = useState<ImageDetail | null>(null); // Store full object for modal

  const fetchArtistGalleryImages = useCallback(async (year: string) => {
    try {
      const res = await axios.post(
        url,
        { params: { year } },
        { headers: { 'Content-Type': 'application/json' } }
      );

      // const groups = ['A', 'B', 'C']; 
      // const combinedData = groups.flatMap(group => 
      //   (res.data?.[group] || []).filter((item: ImageDetail) => 
      //     item.age.includes(`Group ${group}`)
      //   ).slice(3) 
      // );

       const groups = ['A', 'B', 'C']; 
        const combinedData: ImageDetail[] = groups.flatMap(group => { 
        const groupData = res.data?.[group]; return (Array.isArray(groupData) ?
         groupData : []).slice(3); 
        });

      setImages(combinedData);
    } catch (error) {
      console.error('Error fetching artist gallery images:', error);
    }
  }, [url]);


  const handleImageClick = (drawing: ImageDetail) => {
    setSelectedDrawing(drawing);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedDrawing(null);
  };

  useEffect(() => {
    fetchArtistGalleryImages('2024');
  }, [fetchArtistGalleryImages]);

  return (
    <>
      <Header />
      <div className="container-fluid mob-pain-winlist">
        <div className="col-md-12">
          <div className="mob-pain-yrs21">
            <div className="yer-2021">
              <img src={mob_winnerboard} alt="paintathon-2024" width="100%" />
            </div>

            <div className="pain-winlist-box24">
              <div className="col-md-12 mb-3">
                <span className="winlis-tit">Artist Gallery</span>
              </div>

              <div className="col-md-12 artist-main">
                <div className="mega-win-container mb-2">
                  <ul className="artist-list">
                    {images.map((item) => (
                      <li key={item.id} className="artbox" onClick={() => handleImageClick(item)}>
                        <img
                          src={`https://assets.etvbalbharat.com/${item.image}`}
                          alt={item.name}
                          width="100%"
                        />
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && selectedDrawing && (
        <div className="modal fade show"  style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" onClick={closeModal}>
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content new-body">
              <div className="modal-header new-mod-head">
                <button type="button"  className="close-btn new-close" onClick={closeModal} aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <img src={`https://assets.etvbalbharat.com/${selectedDrawing.drawing}`} width="100%" alt="Drawing" />
                <div className="drw-cand-name">
                  {selectedDrawing.name}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}



